import React from "react"

import { useCurrentOutfitter } from "~components/providers/current-outfitter-provider"
import { TEST_IDS } from "~config/test-ids"
import LodgingsCollectionWithModal from "~components/shared/collections/lodgings-collection-with-modal"

export default function OutfitterLodgings() {
    const { currentOutfitter } = useCurrentOutfitter()

    return (
        <LodgingsCollectionWithModal
            testId={TEST_IDS.OUTFITTER_LODGINGS}
            lodgings={currentOutfitter.lodgings}
        />
    )
}
